// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_3gBBD","title":"_3jo41"};